// report.service.ts
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { BehaviorSubject, catchError, Observable, throwError } from 'rxjs';
import { UserService } from '../users/users.service';
import { TaskService } from '../task/task.service';
import { SalesData } from '@org/interfaces';

@Injectable({
  providedIn: 'root'
})
export class ReportService {
  private salesDataSubject = new BehaviorSubject<SalesData[]>([]);
  salesData$ = this.salesDataSubject.asObservable();

  private apiUrl = `${environment.apiUrl}/api/reports`;
  private apiSalesDataUrl = `${environment.apiUrl}/api/salesdata`;

  constructor(private http: HttpClient, private userService: UserService, private taskService: TaskService) { }

  getTaskCompletionReport(startDate: string, endDate: string): Observable<any> {
    const params = new HttpParams().set('startDate', startDate!).set('endDate', endDate!);
    return this.taskService.getTaskCompletionReport(startDate, endDate);
  }

  fetchRoles(): Observable<any> {
    return this.userService.getRoles();
  }

  postSalesData(data: SalesData): Observable<SalesData> {
    return this.http.post<SalesData>(`${this.apiSalesDataUrl}/entry`, data).pipe(
      catchError(this.handleError))
  }

  getSalesData(): void { 
    this.http.get<SalesData[]>(`${this.apiSalesDataUrl}`).subscribe({
      next: (response) => {
        this.salesDataSubject.next(response);
      },
      error: (error) => {
        console.error('Error fetching sales data', error);
      }
    });
  }

  getRolling12MonthsSales(): void {
    this.http.get<SalesData[]>(`${this.apiSalesDataUrl}/sales/rolling-12-months`).subscribe({
      next: (response) => {
        this.salesDataSubject.next(response);
      },
      error: (error) => {
        console.error('Error fetching rolling 12 months sales data', error);
      }
    });
  }

  // Update sales data
  updateSalesData(salesData: SalesData): Observable<any> {
    return this.http.put(`${this.apiSalesDataUrl}/${salesData._id}`, salesData)
      .pipe(catchError(this.handleError)); // Assuming the API expects a PUT request
  }

  // Delete sales data
  deleteSalesData(salesId: string | undefined): Observable<any> {
    return this.http.delete(`${this.apiSalesDataUrl}/${salesId}`)
      .pipe(catchError(this.handleError));
  }
  



  // Handle HTTP errors
  private handleError(error: HttpErrorResponse) {
    // Customize the error handling logic as needed
    let errorMessage = 'An unknown error occurred!';
    if (error.error instanceof ErrorEvent) {
      // Client-side or network error
      errorMessage = `Error: ${error.error.message}`;
    } else {
      // Backend error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(() => new Error(errorMessage));
  }













}
